/**
  表单配置接口 
*/
import { api, formatParams, config } from "@/utils/axios";

// 新增动态表格配置
export function add(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/tableConfig`,
    })
  );
}

// 获取动态表单配置列表
export function page(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/tableConfig/page?currentNo=${params.currentNo}&pageSize=${params.pageSize}`,
    })
  );
}

// 表格查被关联表
export function findNowTableSon(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/tableConfig/findNowTableSon?tableId=${params.tableId}`,
    })
  );
}

// 修改动态表格配置
export function update(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/tableConfig/${params.id}`,
    })
  );
}

// 获取动态表单配置详情
export function details(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/tableConfig/${params.id}`,
    })
  );
}

// 删除动态表单配置
export function del(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/tableConfig/remove/${params.id}`,
    })
  );
}
